(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    // Desktop shows the filter column permanently (the <details> is
    // rendered open); on phones it starts collapsed behind "Filter".
    var disclosure = document.querySelector('[data-facets-disclosure]');
    if (disclosure) {
      var wide = window.matchMedia('(min-width: 901px)');
      disclosure.open = wide.matches;
      wide.addEventListener('change', function () {
        if (wide.matches) disclosure.open = true;
      });
    }

    var facetsForm = document.querySelector('[data-facets-form]');
    if (facetsForm) {
      facetsForm.addEventListener('change', function (event) {
        if (event.target.type === 'checkbox') facetsForm.submit();
      });
    }

    var sortForm = document.querySelector('[data-sort-form]');
    if (sortForm) {
      sortForm.addEventListener('change', function () {
        sortForm.submit();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    /*
      Re-opens Shopify's own cookie banner preferences (Customer Privacy,
      Cookie Banner API: privacyBanner.showPreferences()). No own consent
      logic. The entry stays hidden unless Shopify's banner API is present,
      e.g. where no banner is shown for the visitor's region.
    */
    var items = document.querySelectorAll('[data-cookie-settings]');
    if (!items.length) return;

    function available() {
      return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    }

    function reveal() {
      if (!available()) return false;
      items.forEach(function (item) {
        item.hidden = false;
      });
      return true;
    }

    items.forEach(function (item) {
      item.querySelector('button').addEventListener('click', function () {
        if (available()) window.privacyBanner.showPreferences();
      });
    });

    if (reveal()) return;
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (reveal() || tries >= 20) window.clearInterval(timer);
    }, 500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;

    var dialog = header.querySelector('#mobile-menu');
    var openBtn = header.querySelector('[data-mobile-menu-open]');
    if (!dialog || !openBtn) return;

    // Lock the page behind the drawer while it is open. The 'close' event
    // covers every way out (button, link, backdrop, Escape).
    openBtn.addEventListener('click', function () {
      dialog.showModal();
      document.documentElement.classList.add('mobile-menu-open');
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('mobile-menu-open');
    });

    dialog.querySelectorAll('[data-mobile-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        dialog.close();
      });
    });

    dialog.addEventListener('click', function (event) {
      var rect = dialog.getBoundingClientRect();
      var inDialog =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (!inDialog) dialog.close();
    });

    // Close the dropdown after keyboard users leave it with Escape.
    header.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var active = document.activeElement;
      if (active && active.closest('.mega')) {
        var trigger = active.closest('.site-nav__item').querySelector('.site-nav__link');
        if (trigger) trigger.focus();
        active.blur();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-finder"]) return;
  try {
    
  // Lead signal for the request form. Shopify Forms calls
  // Shopify.analytics.visitor() only after its API accepted a submission
  // (failed or cancelled submissions return before that call). That call is
  // turned into one custom customer event without any form content; the
  // custom pixel "Lead Schlüssel-Anfrage" (Settings → Customer events) sends
  // it to GA4 (generate_lead) and Google Ads only with visitor consent.
  (function () {
    var host = document.querySelector('[data-lead-signal]');
    if (!host) return;
    var sent = false;

    // Shopify can replace window.Shopify.analytics after this script ran
    // (seen with a filled cart), so the wrapper is (re)applied on load and
    // on every interaction with the form – always before Forms submits.
    function wrap() {
      var analytics = window.Shopify && window.Shopify.analytics;
      if (!analytics || typeof analytics.visitor !== 'function' || typeof analytics.publish !== 'function') return;
      if (analytics.visitor.keyInquiryLead) return;
      var visitor = analytics.visitor;
      var wrapped = function () {
        // Published before the original call, which throws on unusable
        // contact data although the request itself was already accepted.
        if (!sent) {
          sent = true;
          analytics.publish('key_inquiry_submitted', { form: host.getAttribute('data-lead-signal') });
        }
        return visitor.apply(this, arguments);
      };
      wrapped.keyInquiryLead = true;
      analytics.visitor = wrapped;
    }

    wrap();
    window.addEventListener('load', wrap);
    ['pointerdown', 'click', 'keydown', 'focusin'].forEach(function (type) {
      host.addEventListener(type, wrap, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var thumbs = document.querySelectorAll('[data-product-thumb]');
    if (!thumbs.length) return;

    var mainImage = document.querySelector('[data-product-main-image] img');
    if (!mainImage) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        // image_tag renders a srcset for the first image; the browser would
        // keep using it and ignore the new src, so drop it before swapping.
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = thumb.getAttribute('data-full-src');
        mainImage.alt = thumb.getAttribute('data-alt') || mainImage.alt;

        thumbs.forEach(function (other) {
          other.classList.remove('is-active');
          other.setAttribute('aria-current', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');

        // A thumbnail that is a variant's image (e.g. a key ring motif)
        // selects that variant, so the picture and the order always match.
        var select = document.querySelector('[data-variant-select]');
        var imageId = thumb.getAttribute('data-image-id');
        if (!select || !imageId) return;
        var current = select.options[select.selectedIndex];
        if (current && current.getAttribute('data-image-id') === imageId) return;
        var match = Array.prototype.find.call(select.options, function (option) {
          return option.getAttribute('data-image-id') === imageId && !option.disabled;
        });
        if (match) {
          select.value = match.value;
          select.dispatchEvent(new Event('change'));
        }
      });
    });
  })();

  // Add to cart without leaving the page. The normal form POST to
  // /cart/add reloads the cart page right away, which drops GA4's
  // add_to_cart (Shopify's Google app batches it and the page is gone).
  // With JavaScript the same form data goes to /cart/add.js, the page stays
  // and a status line links to the cart. Tracking still comes only from
  // Shopify's own cart event; nothing is sent from here. Without
  // JavaScript (or fetch) the form posts as before.
  (function () {
    if (!window.fetch || !window.FormData) return;
    document.querySelectorAll('[data-ajax-cart]').forEach(function (status) {
      var form = status.closest('form');
      if (!form) return;
      var submit = form.querySelector('[type="submit"]');

      function updateCount(count) {
        var icon = document.querySelector('.site-header__cart .header-action__icon');
        if (!icon) return;
        var badge = icon.querySelector('.site-header__cart-count');
        if (count > 0 && !badge) {
          badge = document.createElement('span');
          badge.className = 'site-header__cart-count';
          icon.appendChild(badge);
        }
        if (badge) {
          if (count > 0) badge.textContent = count;
          else badge.remove();
        }
      }

      function showAdded() {
        status.classList.remove('product__cart-status--error');
        status.textContent = status.getAttribute('data-text-added') + ' ';
        var link = document.createElement('a');
        link.href = status.getAttribute('data-cart-url');
        link.textContent = status.getAttribute('data-text-view-cart');
        status.appendChild(link);
      }

      function showError(message) {
        status.classList.add('product__cart-status--error');
        status.textContent = message || status.getAttribute('data-text-error');
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (form.getAttribute('aria-busy') === 'true') return;
        form.setAttribute('aria-busy', 'true');
        if (submit) submit.disabled = true;
        status.textContent = '';
        fetch(status.getAttribute('data-cart-add-url') + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function () {
            showAdded();
            return fetch(status.getAttribute('data-cart-url') + '.js', { headers: { Accept: 'application/json' } })
              .then(function (response) { return response.json(); })
              .then(function (cart) { updateCount(cart.item_count); })
              .catch(function () {});
          })
          .catch(function (error) {
            showError(error && error.description);
          })
          .then(function () {
            form.removeAttribute('aria-busy');
            if (submit) submit.disabled = false;
          });
      });
    });
  })();

  // Variant select: keep price, compare-at price, availability, quantity,
  // button state and ?variant= in sync with the selected option. The data
  // comes from the option's data-* attributes rendered by Liquid; the
  // select itself is the name="id" field the cart receives.
  (function () {
    document.querySelectorAll('[data-variant-select]').forEach(function (select) {
      var root = select.closest('.product__info');
      if (!root) return;

      var price = root.querySelector('[data-variant-price]');
      var compare = root.querySelector('[data-variant-compare]');
      var availableLine = root.querySelector('[data-variant-available]');
      var unavailableLine = root.querySelector('[data-variant-unavailable]');
      var leadTime = root.querySelector('[data-variant-lead-time]');
      var quantity = root.querySelector('[data-variant-quantity]');
      var submit = root.querySelector('[data-variant-submit]');
      var sku = root.querySelector('[data-variant-sku]');

      function update(updateUrl) {
        var option = select.options[select.selectedIndex];
        if (!option) return;
        var available = option.getAttribute('data-available') === 'true';
        var compareText = option.getAttribute('data-compare');

        if (price) price.textContent = option.getAttribute('data-price');
        if (compare) {
          compare.textContent = compareText || '';
          compare.hidden = !compareText;
        }
        if (availableLine) availableLine.hidden = !available;
        if (unavailableLine) unavailableLine.hidden = available;
        if (leadTime) leadTime.hidden = !available;
        if (quantity) quantity.hidden = !available;
        if (sku) sku.textContent = option.getAttribute('data-sku');

        // Show the variant's own image (motif) when it has one.
        var imageId = option.getAttribute('data-image-id');
        if (imageId) {
          var thumb = document.querySelector('[data-product-thumb][data-image-id="' + imageId + '"]');
          if (thumb && !thumb.classList.contains('is-active')) thumb.click();
          // Phones: the thumbnail row scrolls sideways – keep the active one in view
          // (horizontal only, the page itself does not move).
          var thumbRow = thumb ? thumb.closest('.product__thumbs') : null;
          if (thumbRow && thumbRow.scrollWidth > thumbRow.clientWidth) {
            var offset = thumb.getBoundingClientRect().left - thumbRow.getBoundingClientRect().left;
            thumbRow.scrollLeft += offset - 8;
          }
        }
        if (submit) {
          submit.disabled = !available;
          submit.textContent = submit.getAttribute(available ? 'data-label-available' : 'data-label-unavailable');
        }

        if (updateUrl && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState(window.history.state, '', url.toString());
        }
      }

      select.addEventListener('change', function () {
        update(true);
      });
      // The browser may restore a different selection (back/forward,
      // reload); sync the display without touching the URL.
      update(false);
      window.addEventListener('pageshow', function () {
        update(false);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
